
import { EventBus, TypeEventBus } from '../../../../core/utils';
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class CentroidIndicator extends Vue {
  @Prop({ default: null }) centroidInfo!: { lat: number; lng: number } | null;
  copied: boolean = false
  timer: number | null = null

  get hasCentroid() {
    return !!(this.centroidInfo && Number.isFinite(this.centroidInfo.lat) && Number.isFinite(this.centroidInfo.lng));
  }

  fmt(n: number) {
    return new Intl.NumberFormat(undefined, { maximumFractionDigits: 6 }).format(n);
  }

  async copyCoords() {
    if (!this.centroidInfo) return
    const text = `${this.centroidInfo.lat}, ${this.centroidInfo.lng}`

    try {
      await navigator.clipboard.writeText(text)
      EventBus.$emit(TypeEventBus.SHOW_MESSAGE, 'Coordenadas copiadas', 'success')
      this.copied = true
      if (this.timer) clearTimeout(this.timer)
      this.timer = window.setTimeout(() => {
        this.copied = false
      }, 2000)
    } catch (e) {
      console.error(e)
    }
  }
}
